import { render } from "./EditPet.vue?vue&type=template&id=b8d01838"
import script from "./EditPet.vue?vue&type=script&lang=js"
export * from "./EditPet.vue?vue&type=script&lang=js"

import exportComponent from "/home/emcy/Dev/FaunaLife/fauna.life_puppy_vue_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QIcon,QPopupProxy,QDate,QSelect,QTooltip,QRadio,QSpinnerIos,QDialog,QCard,QCardSection,QAvatar,QCardActions});qInstall(script, 'directives', {ClosePopup});
